import type { SVGProps } from 'react';

export const Caret = (props: SVGProps<SVGSVGElement>) => (
    <svg fill='currentColor' width='10' height='10' viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M4.29 7.29 0 3h10L5.71 7.29a1 1 0 0 1-1.42 0Z' />
    </svg>
);
